const SYSTEM_GROUPS = {
    Employees: 1,
    Partners: 2,
    Customers: 3,
    Other: 4,
    Public:5
}
export default SYSTEM_GROUPS;